import type { Currency } from '../../api/common/model/customer';

type FormatType = 'string' | 'array';

export const prettifyPriceWithCurrencySymbol = (
  currency: Currency = 'EUR',
  maximumFractionDigits?: number,
): typeof prettifyPrice => {
  function prettifyPrice(price: number, output?: 'string'): string;
  function prettifyPrice(price: number, output?: 'array'): string[];
  function prettifyPrice(price: number, output: FormatType = 'string'): string | string[] {
    const { language } = window.navigator;
    const numberFormatInstance = new Intl.NumberFormat(language, {
      style: 'currency',
      currency,
      maximumFractionDigits,
    });
    return output === 'string'
      ? numberFormatInstance.format(price)
      : numberFormatInstance.formatToParts(price).map((p) => p.value);
  }

  return prettifyPrice;
};

interface UsePrettifyPriceResult {
  prettifyPrice: ReturnType<typeof prettifyPriceWithCurrencySymbol>;
}

export function usePrettifyPrice(
  currency: Currency,
  maximumFractionDigits?: number,
): UsePrettifyPriceResult {
  return {
    prettifyPrice: prettifyPriceWithCurrencySymbol(currency, maximumFractionDigits),
  };
}
